// extracted by mini-css-extract-plugin
export default {"inner-container":"role-selection-page_inner-container__5XmcG","title":"role-selection-page_title__SVQqa","item":"role-selection-page_item__CyHJW"};